import { gql } from "@apollo/client";

export const REMOVE_TASK = gql`
  mutation removeTask($_id: String!) {
    removeTask(_id: $_id)
  }
`;
